<script setup>
// Placeholder — Notifications tab. Future: weekly progress summary opt-in,
// per-event email controls (driven by saas-core's Event Dispatch).
</script>

<template>
  <div class="card border-0 shadow-sm">
    <div class="card-body">
      <h2 class="h5 mb-3"><i class="bi bi-bell me-2"></i>Notifications</h2>
      <p class="text-muted mb-0">
        Per-user email and SMS preferences. Will be driven by saas-core's
        Event Dispatch once we wire per-user opt-in/opt-out.
      </p>
    </div>
  </div>
</template>
